import dayjs, { Dayjs } from 'dayjs'
import { MatchStatus } from '../../utils/statsperform/types'
import { STATUS_LABEL } from '../../config/statsperformConfig'
import React from 'react'
import { ReactComponent as Live } from '../../assets/live.svg'
import style from './style.module.scss'

interface LiveMatchStatusProps {
    status: MatchStatus
    date: Dayjs | string | null
    defaultDisplay?: React.ReactNode
}

export const LiveMatchStatus = ({ status, date, defaultDisplay }: LiveMatchStatusProps) => {
    const dateDayJs = dayjs(date)
    switch (status) {
        case 'Playing':
            return (
                <div className={style.component}>
                    <Live />
                    <span>en direct</span>
                </div>
            )
        case 'Awarded':
        case 'Cancelled':
        case 'Played':
        case 'Suspended':
            return <span>{STATUS_LABEL[status]}</span>
        case 'Postponed':
        default:
            const isToday = dateDayJs.isSame(dayjs(), 'day')
            if (defaultDisplay !== undefined) return <>{defaultDisplay}</>
            return (
                <span>
                    {isToday ? "Aujourd'hui" : dateDayJs.format('L')} à {dateDayJs.format('LT')}
                </span>
            )
    }
}
